import { useRepositoryQuery } from '@mews-commander/data-access';
import { LedgersDatePicker } from '../../common/filters';
import { useGuestLedgerSelectedDate } from '../context/GuestLedgerFilterContext';

export const GuestLedgerHeader = () => {
    const { selectedDate, setSelectedDate } = useGuestLedgerSelectedDate();
    const { data } = useRepositoryQuery('accounting', 'getEffectiveDate', {});
    return (
        <LedgersDatePicker
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            effectiveDate={data?.effectiveDate}
        />
    );
};
